<template>
  <b-row class="Settings mb-2">
    <b-col cols="12" lg="8" offset-lg="2">
      <Notification v-bind.sync ="notification" />
      <b-card no-body style="min-height: 70vh;">
        <b-overlay
          :show="isLoadingRequest"
          variant="light"
          opacity="0.85"
          spinner-variant="primary"
        >
          <b-card-title title-tag="h2" class="text-center mb-5 p-3">
            SYSTEM SETTINGS
          </b-card-title>

          <b-card-header class="border d-flex justify-content-between">
            <h4 class="mb-0 d-inline-block">TIMESHEET</h4>
            <b-button
              squared
              variant="primary"
              class="d-inline-block"
              @click="save('timesheet')"
              :disabled="!changedValues.length"
            >
              <v-icon name="save" />
              Save
            </b-button>
          </b-card-header>
          <b-card-body class="row">
            <b-col cols="12" lg="6" class="mb-3 mb-lg-0">
              <b-form-checkbox
                switch
                class="font-weight-bold"
                v-model="formObject.enableTimesheetSubmit"
              >
                {{ $get(fields, 'enable_timesheet_submit.label', '-') }}
                <!-- TODO: change variant and text depending on value of setting -->
                <b-badge :variant="$get(timesheetOptions, 'submission.variant', 'primary')">
                  {{ $get(timesheetOptions, 'submission.text', 'DISABLED') }}
                </b-badge>
              </b-form-checkbox>
            </b-col>
            <!-- <b-col cols="12" lg="6"> -->
              <!-- TODO: preview; display dismissible (30sec auto dismiss) alert on top -->
              <!-- TODO: alert variant/icon/duration settings -->
              <!-- <label for="timesheet_notice_message" class="font-weight-bold">
                {{ $get(fields, 'timesheet_notice_message.label', '-') }}
                <b-badge variant="warning">WIP: NOT AVAILABLE</b-badge>
              </label>
              <b-form-textarea
                disabled
                name="timesheet_notice_message"
                class="no-outline border-dark rounded-0"
                style="min-height: 100px;"
                v-model="formObject.timesheetNoticeMessage"
              />
            </b-col> -->
          </b-card-body>

          <!-- <b-card-header header-tag="h4" class="border">OTHERS</b-card-header>
          <b-card-body>
            <b-form-checkbox
              switch
              class="font-weight-bold"
              v-model="formObject.forgotPassword"
            >
              {{ $get(fields, 'forgot_password.label', '-') }}
            </b-form-checkbox>
          </b-card-body> -->
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseService from '@/services/BaseService';
import Notification from '@/components/Notification';

const service = new BaseService();

export default {
  name: 'Settings',
  components: {
    Notification,
  },
  mounted() {
    this.startLoadingRequest();
    service.get('/system/settings')
      .then(({ success, data }) => {
        if (success) {
          this.settingsData = data;
          this.updateForm();
        }
      })
      .catch(() => {
        this.setAlert({
          show: 5,
          variant: 'danger',
          fade: true,
          dismissible: true,
          message: 'An error occurred',
          icon: {
            name: 'exclamation',
          },
        });
      })
      .then(() => this.stopLoadingRequest());
  },
  data() {
    return {
      settingsData: [],
      formObject: {},
    };
  },
  computed: {
    fields() {
      if (this.$ie(this.settingsData)) {
        return {};
      }

      const fieldsObj = {};
      this.settingsData.forEach((setting, idx) => {
        const settingName = this.$get(setting, 'name', `setting${idx}`);
        const item = {
          label: this.$get(setting, 'description', setting.name || ''),
          value: this.$get(setting, 'value', null),
          formObjectField: this.$camel(settingName),
          settingId: this.$get(setting, 'id', null),
        };
        fieldsObj[settingName] = item;
      });

      return fieldsObj;
    },
    timesheetOptions() {
      const submitIsEnabled = this.$get(this.formObject, 'enableTimesheetSubmit', null);
      return {
        submission: {
          variant: submitIsEnabled ? 'success' : 'warning',
          text: submitIsEnabled ? 'ENABLED' : 'DISABLED',
        },
      };
    },
    settingsGroupings() {
      return {
        timesheet: ['enableTimesheetSubmit', 'timesheetNoticeMessage'],
        others: ['forgotPassword'],
      };
    },
    changedValues() {
      return (this.settingsData || []).filter((setting) => {
        const val = this.$get(setting, 'value', '');
        const key = this.$get(setting, 'name', '');
        const camelKey = this.$camel(key);
        const formVal = this.$get(this.formObject, camelKey, -1);
        switch (camelKey) {
          case 'enableTimesheetSubmit':
          case 'forgotPassword':
            return Boolean(Number(val)) !== formVal;
          default: break;
        }
        return val !== formVal;
      }).map(setting => this.$camel(this.$get(setting, 'name', '')));
    },
    ...mapState(['notification']),
    ...mapGetters(['isLoadingRequest', 'isAdmin']),
  },
  methods: {
    updateForm() {
      if (this.settingsData.length > 0) {
        this.settingsData.forEach((setting) => {
          const val = this.$get(setting, 'value', '');
          const key = this.$get(setting, 'name', '');
          const camelKey = this.$camel(key);
          switch (camelKey) {
            case 'forgotPassword':
            case 'enableTimesheetSubmit':
              this.$set(this.formObject, camelKey, Boolean(Number(val)));
              break;
            default:
              this.$set(this.formObject, camelKey, val);
              break;
          }
        });
      }
    },
    updateSettingsData() {
      const keys = Object.keys(this.formObject);
      const keysToUpdate = keys.filter(name => this.changedValues.includes(name));
      keysToUpdate.forEach((k) => {
        const snakeKey = this.$snake(k);
        const updateIdx = this.settingsData.findIndex(s => s.name === snakeKey);
        if (updateIdx > -1) {
          this.settingsData[updateIdx].value = this.formObject[k];
        }
      });
    },
    save(settingsGroup) {
      // list of settings to update
      const settingsToCheck = this.$get(this.settingsGroupings, settingsGroup, []);
      const newValues = settingsToCheck.filter(name => this.changedValues.includes(name));
      const payload = this.$pick(this.formObject, newValues);

      this.startLoadingRequest();

      service.post('/system/settings/', this.$mopc(payload))
        .then(({ success, message }) => {
          if (!success) {
            this.setNotification({
              message: message || 'An error occurred.',
              show: 3,
              variant: 'danger',
              icon: { name: 'exclamation-triangle' },
            });
            return;
          }
          this.updateSettingsData();
          this.setNotification({
            show: true,
            dismissible: true,
            message: message || 'Settings updated.',
            variant: 'success',
            icon: { name: 'check' },
          });
        })
        .catch(() => this.setNotification({
          message: 'An error occurred.',
          show: 3,
          variant: 'danger',
          icon: { name: 'exclamation-triangle' },
        }))
        .then(() => this.stopLoadingRequest());
    },
    ...mapActions([
      'setNotification',
      'startLoadingRequest',
      'stopLoadingRequest',
    ]),
  },
};
</script>
